module.exports = __webpack_public_path__ + "img/refresh-icon.ef98cf01.svg";